import React, { useState, useEffect } from 'react';
import colors from '../../utils/colors';
import typography from '../../utils/typography';

const IncomingMessageLoading = () => {
  const [seconds, setSeconds] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setSeconds(prev => prev + 1);
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="flex justify-start">
      <div className="flex gap-[5px] items-center">
        {/* Spinning Loader */}
        <div className="relative w-[40px] h-[40px] rounded-full flex-shrink-0">
          <div className="absolute inset-0 flex items-center justify-center">
            <svg
              className="animate-spin"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="12"
                cy="12"
                r="10"
                stroke={colors.accent.brand}
                strokeWidth="3"
                strokeLinecap="round"
                strokeDasharray="60"
                strokeDashoffset="15"
              />
            </svg>
          </div>
        </div>

        {/* Shimmering Gradient Text */}
        <p
          style={{
            ...typography.small.title,
            background: `linear-gradient(90deg, ${colors.text.primary} 0%, ${colors.accent.brand} 50%, ${colors.text.primary} 100%)`,
            backgroundSize: '200% 100%',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            animation: 'shimmer 2s linear infinite'
          }}
        >
          Crafting
        </p>

        {/* Separator Dot */}
        <p
          style={{
            ...typography.small.title,
            color: colors.text.inactive
          }}
        >
          ·
        </p>

        {/* Timer */}
        <p
          style={{
            ...typography.small.title,
            color: colors.text.inactive
          }}
        >
          {seconds}s
        </p>

        {/* Add shimmer keyframes to document if not already there */}
        <style>{`
          @keyframes shimmer {
            0% {
              background-position: 200% 0;
            }
            100% {
              background-position: -200% 0;
            }
          }
        `}</style>
      </div>
    </div>
  );
};

export default IncomingMessageLoading;